<template>
    <div v-bind:style="{
        height: '100%',
        'min-height': '100vh',
        'background-color': '#F8F9FA',
        color: '#004284',
        'background-size': $store.state.fiduciary.background_size,
    }">

        <div class="client_application">
            <b-modal ok-only no-close-on-backdrop no-close-on-esc hide-header-close id="terms"
                title="Conditions générales d'utilisation" @ok="acceptTermsOfService()"
                ok-title="J'accepte les conditions">
                Pour pouvoir continuer à utiliser ce site, merci d'accepter
                <a :href="termsOfService()">
                    nos conditions générales d'utilisation.
                </a>
            </b-modal>

            <router-view @error="showErrorMessage" v-if="this.$store.state.fiduciary.id != null"
                :key="this.$store.state.fiduciary.id"></router-view>
        </div>
    </div>
</template>

<style>
html {
    font-size: 13px;
}

h4,
.h4,
h5,
.h5,
h6,
.h6 {
    margin-top: 10px;
    margin-bottom: 10px;
}
</style>

<script>

import axios from "axios";

export default {
    data: function () {
        return {
            errorMessage: null,
        };
    },
    watch: {
        $route(to, from) {
            return this.$store
                .dispatch("get_fiduciary")
                .then(this.get_redirect_params)
                .then(() => this.$store.dispatch("get_companies"))
                .then(() => this.redirect_good_readable_safe_url(to));
        },
    },
    methods: {
        termsOfService: function () {
            if (this.$store.state.user.user_typology === "customer") {
                return "https://chaintrust-cgus.s3.eu-west-3.amazonaws.com/CGU_CLIENTS.pdf";
            } else {
                return "https://chaintrust-cgus.s3.eu-west-3.amazonaws.com/CGU_EC.pdf"
            }
        },
        acceptTermsOfService: function () {
            let token = document.head.querySelector(
                "[name~=csrf-token][content]"
            ).content;
            axios.defaults.headers.common["X-CSRF-TOKEN"] = token;
            axios.put(`/users/${this.$store.state.user.id}/`, {
                user: { terms_of_service_accepted: true },
            });
        },
        triggerTermsOfServiceModal: function () {
            this.$root.$emit("bv::show::modal", "terms");
        },
        redirect_good_readable_safe_url: function (to) {
            if (this.$route.path.includes("/blocked_user_display")) {
                return;
            }
            let good_readable_safe_url =
                this.$store.state.fiduciary.readable_safe_url;
            if (
                this.redirect_params &&
                this.$route.name == "ClientApplication"
            ) {
                this.set_redirect_params().then(() =>
                    this.$router.push(this.redirect_params)
                );
            } else if (
                this.$store.state.user.deactivated_at ||
                this.$store.state.fiduciary.admin_deactivated_at
            ) {
                this.$router.push({
                    path: `/${this.$route.params.readable_safe_url}/blocked_user_display`,
                });
            } else if (to && to.name == "ClientApplication") {
                this.$router.push({
                    path: `/${to.params.readable_safe_url}/companies`,
                });
            } else if (
                this.$route.params.readable_safe_url != good_readable_safe_url
            ) {
                this.$router.push({
                    name: "ClientApplication",
                    params: { readable_safe_url: good_readable_safe_url },
                });
            } else if (to && to.name == "Companies") {
                this.only_one_company();
            }
        },
        only_one_company: function () {
            if (this.$route.path.includes("/blocked_user_display")) {
                return;
            }
            if (this.$store.state.companies.length === 1) {
                let company = this.$store.state.companies.find(
                    (company) =>
                        company["id"] == this.$store.state.companies[0].id
                );
                if (
                    this.$store.state.user.user_typology === "customer" &&
                    (!company.standard_ledgers.find((sl) => {
                        return sl.confirmed;
                    }) ||
                        company.fiscal_years.length < 1)
                ) {
                    this.$router.push({
                        path: `/${this.$route.params.readable_safe_url}/blocked_user_display`,
                    });
                }
                if (!this.$route.path.includes("/company/")) {
                    this.$router.push({
                        name: "Company",
                        params: {
                            readable_safe_url:
                                this.$route.params.readable_safe_url,
                            id: this.$store.state.companies[0].id,
                        },
                    });
                }
            }
        },
        get_fiduciary: function () {
            let token = document.head.querySelector(
                "[name~=csrf-token][content]"
            ).content;
            axios.defaults.headers.common["X-CSRF-TOKEN"] = token;
            return this.$store
                .dispatch("get_fiduciary")
                .then(this.get_redirect_params)
                .then(() => this.$store.dispatch("get_companies"))
                .then(this.redirect_good_readable_safe_url)
                .then(this.only_one_company)
                .catch((error) => {
                    let errorMsg =
                        error.response.data.error ||
                        error.response.request.statusText;
                    this.$emit("error", errorMsg);
                });
        },

        get_redirect_params: function () {
            return axios
                .get("/users/get_redirect_params")
                .then(
                    (response) =>
                    (this.redirect_params =
                        response.data["redirect_params"])
                );
        },

        set_redirect_params: function () {
            return axios.post("/users/set_redirect_params");
        },

        showErrorMessage: function (error) {
            this.errorMessage = error;
            this.adaptMarginToNavbarHeight();
        },
        removeError: function () {
            this.errorMessage = null;
            this.adaptMarginToNavbarHeight();
        },
        adaptMarginToNavbarHeight: function () {
            let application =
                document.getElementsByClassName("client_application")[0];
            if (navbar) {
                application.style["margin-top"] = `${navbar.offsetHeight * 1.05
                    }px`;
            }
        },
    },
    mounted: function () {
        let token = document.head.querySelector(
            "[name~=csrf-token][content]"
        ).content;
        axios.defaults.headers.common["X-CSRF-TOKEN"] = token;
        this.get_fiduciary().then((response) => {
            if (!this.$store.state.user.terms_of_service_accepted_at) {
                this.triggerTermsOfServiceModal();
            }
        });
        window.addEventListener("resize", this.adaptMarginToNavbarHeight);
    },
    destroyed: function () {
        window.removeEventListener("resize", this.adaptMarginToNavbarHeight);
    },
};
</script>
